import React, { useCallback, useState } from 'react';
import { TabPanel, Tabs } from '@pega/cosmos-react-core';
import Home from './Home';
import styled from 'styled-components';
import Monitor from './monitor/Monitor';
import ConfigureHome from './configure/ConfigureHome';
import { usePlatformVersionSelector } from '../redux/selectors';

const StyledTabs = styled(Tabs)`
  margin-block-start: 24px;
`;

const firstTab = 'Develop';
const secondTab = 'Monitor';
const thirdTab = 'Configure';

const LandingPage = () => {
  const { majorVersion, minorVersion } = usePlatformVersionSelector();
  const beyondEightDotSeven =
    majorVersion && (majorVersion > 8 || (majorVersion === 8 && minorVersion && minorVersion >= 7));
  const [activeTab, setActiveTab] = useState('0');

  const getBaseTabs = useCallback(() => {
    let arr: string[];

    arr = [firstTab, secondTab];
    if (beyondEightDotSeven) {
      arr.push(thirdTab);
    }

    return arr.map((tabName, index) => ({
      name: tabName,
      id: index.toString(),
      label: tabName,
    }));
  }, [beyondEightDotSeven]);

  const TabsName = getBaseTabs();

  const renderTabContent = (tabName: string) => {
    switch (tabName) {
      case firstTab:
        return <Home />;
      case secondTab:
        return <Monitor />;
      case thirdTab:
        return <ConfigureHome />;
      default:
        return '';
    }
  };

  const handleTabClick = (data: string) => {
    setActiveTab(data);
  };

  return (
    <>
      <StyledTabs tabs={TabsName} currentTabId={activeTab} onTabClick={handleTabClick}></StyledTabs>
      <TabPanel tabId={activeTab}>{renderTabContent(TabsName[parseInt(activeTab, 10)].label)}</TabPanel>
    </>
  );
};

export default LandingPage;
